(function () {
  function getSubsVariant() {
    var v = (sessionStorage.getItem('subs_variant') || '').toLowerCase();
    return v || 'rc'; // default = Recharge
  }

  // Hide Kaching bundles unless kb variation is active
  var subs = getSubsVariant();
  var hideKachingBundles = subs !== 'kb';
  if (!hideKachingBundles) return;

  // OPTIONAL: only run on product pages
  // If you have a better product-page signal, use that instead.
  var isProductPage =
    document.body && (
      document.body.classList.contains('template-product') ||
      document.body.className.indexOf('template-product') !== -1
    );

  if (!isProductPage) return;

  document.documentElement.setAttribute('data-hide-kaching-bundles', 'true');

  function killBundlesOnly() {
    // Remove only the bundles widget custom elements
    document.querySelectorAll('kaching-bundle, kaching-bundles-block').forEach(function (el) {
      el.remove();
    });

    // Remove only app blocks that look like bundles (NOT cart)
    document.querySelectorAll('.shopify-app-block').forEach(function (el) {
      var cls = (el.className || '').toLowerCase();
      if (cls.indexOf('kaching') !== -1 && cls.indexOf('cart') === -1) {
        // if Kaching uses distinct classes for bundles, you can tighten this further
        // e.g. cls.includes('bundles') or cls.includes('bundle')
        el.remove();
      }
    });
  }

  killBundlesOnly();
  document.addEventListener('DOMContentLoaded', killBundlesOnly, { once: true });

  // Keep removing if it re-injects on variant change, etc.
  new MutationObserver(killBundlesOnly).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
